module.exports = __webpack_public_path__ + "img/change.9edf0256.svg";